/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import type { QueryFunctionContext, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { DomainListShopOrderCountsResponse } from '@/Swagger';
import type { OrderCountsRequest } from '@/app/orders/common/type';
import { queryKeys } from '@/app/queryKeys';
import axiosInstance from '@/axios/axios';
import type { ExtractQueryFunction, UseAxiosQueryOptions } from '@/utils/typeHelper';

type QueryOptions = UseAxiosQueryOptions<
  DomainListShopOrderCountsResponse,
  ReturnType<typeof queryKeys.orderCountsByShopID>
>;

const queryFn: ExtractQueryFunction<QueryOptions> = ({ queryKey }) => {
  const [, , { shopID, request }] = queryKey;
  return axiosInstance
    .get<DomainListShopOrderCountsResponse>(`/shops/${shopID}/order-counts`, {
      params: { ...request },
    })
    .then(v => v.data);
};

/**
 * 샵의 주문의 상태별 카운트를 조회합니다.
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Orders/get_shops__shopID__order_counts
 */
export default function useGetOrderCounts(
  shopID: string,
  request: OrderCountsRequest,
  option?: Partial<
    UseQueryOptions<
      DomainListShopOrderCountsResponse,
      AxiosError,
      DomainListShopOrderCountsResponse,
      [string, string, { shopID: string; request: OrderCountsRequest }]
    >
  >,
) {
  return useQuery({
    queryKey: queryKeys.orderCountsByShopID(shopID, request),
    queryFn: queryFn,
    enabled: !!shopID,
    ...option,
  });
}
